import { render, staticRenderFns } from "./EvaluationsOverview.vue?vue&type=template&id=61e36906&scoped=true&"
import script from "./EvaluationsOverview.vue?vue&type=script&lang=js&"
export * from "./EvaluationsOverview.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationsOverview.vue?vue&type=style&index=0&id=61e36906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e36906",
  null
  
)

export default component.exports